import { ScreenProtocolMessage } from "../../../ScreenProtocol";
import { BigSymbolFreegamesSession } from "./BigSymbolFreegamesSession";

export namespace BigSymbolFreegamesMessages {
	
	export class SpinMessage extends ScreenProtocolMessage
	{
		public static readonly msgname = "spin";
		public session: BigSymbolFreegamesSession = null;

		constructor(session: BigSymbolFreegamesSession) {
			super(SpinMessage.msgname);
			this.session = session;
		}
	}

	export class PlusMessage extends ScreenProtocolMessage
	{
		public static readonly msgname = "plus";
		public session: BigSymbolFreegamesSession = null;

		constructor(session: BigSymbolFreegamesSession) {
			super(PlusMessage.msgname);
			this.session = session;
		}
	}


	export class ShowWinContainer extends ScreenProtocolMessage
	{
		public static readonly msgname = "showwincontainer";
		public session: BigSymbolFreegamesSession = null;

		constructor(session: BigSymbolFreegamesSession) {
			super(ShowWinContainer.msgname);
			this.session = session;
		}
	}

	export class ResetFinalContainerWin extends ScreenProtocolMessage
	{
		public static readonly msgname = "resetwinshowcontainer";
		public session: BigSymbolFreegamesSession = null;

		constructor(session: BigSymbolFreegamesSession) {
			super(ResetFinalContainerWin.msgname);
			this.session = session;
		}
	}

	
	export class TitleAnim  extends ScreenProtocolMessage
	{
		public static readonly msgname = "TitleAnim";
		
		constructor( ) {
			super(TitleAnim.msgname);
			
		}
	}
}